<script setup lang="tsx">
const emit = defineEmits(['click'])

const props = defineProps({
	right: { type: String, default: '.5rem' },
})
</script>

<template>
	<i class="bi bi-x-circle-fill clear" @mousedown.prevent.stop="emit('click')" :style="'right:' + props.right"></i>
</template>

<style lang="sass" scoped>
@import ~bootstrap/scss/functions
@import ~bootstrap/scss/variables

.clear
    position: absolute
    cursor: pointer
    z-index: 5
    color: $secondary
    top: $input-padding-y

    :hover
        color: $primary
</style>
